<template>
  <div class="app-input-plus-minus">
    <v-icon :color="value === 0 ? 'gray' : 'black'" @click="decrement">
      remove
    </v-icon>
    <v-text-field
      color="secondary"
      :id="id"
      type="number"
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      :maxLength="maxLength"
      :minLength="minLength"
      @input="input"
      @blur="blur"
      @keypress="keypress"
    >
      <div v-bind:id="id" slot="label" :class="{ 'required-field': isRequired }">
        <span>{{ label }}</span>
      </div>
    </v-text-field>
    <v-icon :color="disabled ? 'gray' : 'black'" @click="increment">
      add
    </v-icon>
  </div>
</template>

<script>
export default {
  name: 'AppInputPlusMinus',

  props: {
    value: {
      type: [String, Number],
      default: () => 0
    },
    maxLength: {
      type: [String, Number],
      default: () => ''
    },
    minLength: {
      type: [String, Number],
      default: () => ''
    },
    label: {
      type: String,
      default: () => ''
    },
    placeholder: {
      type: String,
      default: () => '0'
    },
    id: {
      type: String
    },
    v: {
      type: Object,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },

  computed: {
    isRequired() {
      return this.v ? this.v.hasOwnProperty('required') : false
    }
  },

  methods: {
    input(value) {
      this.$emit('input', value)
    },

    blur(value) {
      this.$emit('blur', value)
    },

    keypress(value) {
      this.$emit('keypress', value)
    },

    increment() {
      if (this.disabled) return
      this.$emit('plus-value')
    },

    decrement() {
      if (this.value <= 0) return
      this.$emit('minus-value')
    }
  }
}
</script>

<style lang="stylus">
.app-input-plus-minus
  display: flex;
  border: 1px solid #E0E0E0;
  height: 50px;
  max-width: 80px
  min-width: 80px
  border-radius: 5px;
  input
    text-align: center;
  .v-text-field
    padding-top: 8px !important;
    margin-top: 0 !important;
  .v-input__slot:before
    border-color: transparent !important;
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button
    -webkit-appearance: none
    margin: 0
    overflow: hidden
  .gray--text
    cursor not-allowed !important;
</style>
